// recipeService.jsx
import { t } from "i18next";
import { generateNewId } from "../utils/recipeUtils";
import { apiRequest } from "./apiService";

const recipesUrl = process.env.REACT_APP_DB_URL + "/recipes";

/** Fetches all recipes from the database */
export const fetchRecipes = async () => {
  try {
    const response = await fetch(`${recipesUrl}.json`);
    if (!response.ok) throw new Error(t("errors.fetchingRecipes"));

    if (!response.ok) throw new Error(t("errors.fetchingRecipes"));

    const data = await response.json();
    return data
      ? Object.entries(data)
          .filter(([_, recipe]) => recipe)
          .map(([key, recipe]) => ({ id: recipe.id, ...recipe }))
      : [];
  } catch (error) {
    handleError("fetchingRecipes", error);
  }
};

/** Adds a new recipe to the database */
export const addRecipe = async (recipe) => {
  try {
    const result = await apiRequest(`${recipesUrl}.json`, "POST", recipe);
    if (!result?.name) throw new Error(t("errors.addingRecipe"));

    return { ...recipe, id: recipe.id };
  } catch (error) {
    handleError("addingRecipe", error);
  }
};

/** Saves a recipe: updates if it exists, otherwise creates a new one */
export const saveRecipe = async (recipeData) => {
  try {
    if (recipeData.id) return await saveRecipeToDB(recipeData.id, recipeData);

    const newId = await generateNewRecipeId();
    return await saveRecipeToDB(newId, { ...recipeData, id: newId });
  } catch (error) {
    handleError("savingRecipe", error);
  }
};

/** Updates an existing recipe */
export const updateRecipe = async (recipe) => {
  if (!recipe?.id) throw new Error(t("errors.invalidRecipeData"));

  try {
    return await saveRecipeToDB(recipe.id, recipe);
  } catch (error) {
    handleError("updatingRecipe", error);
  }
};

/** Helper function: Saves a recipe to the database */
const saveRecipeToDB = async (id, recipeData) => {
  const requireAuth = !!recipeData.createdBy; // only authenticated users need token
  console.log("recipeData.createdBy", recipeData.createdBy, requireAuth)
  await apiRequest(`${recipesUrl}/${id}.json`, "PUT", recipeData, requireAuth);
  return recipeData;
};

/** Helper function: Fetches all recipes and generates a unique ID */
const generateNewRecipeId = async () => {
  const allRecipes = await fetchRecipes();
  return generateNewId(allRecipes);
};

/** Error handling function */
const handleError = (errorKey, error) => {
  console.error(`${t(`errors.${errorKey}`)}: ${error.message}`, error);
  throw new Error(t(`errors.${errorKey}`));
};
